function getCleanStatus (status) {
  if (typeof status === 'string') {
    return status.split('-')[0].trim()
  }
  return ''
}

export {
  getCleanStatus
}
